import { ATTRIBUTION_MODEL_LABELS, type AttributionModel } from '@/api/types'

import { TooltipBadge } from './TooltipBadge'

/** One model, or — a side-by-side comparison — all four at once. */
export type TmtModelScope = AttributionModel | 'all'

/** The words every TmT-attributed figure is labelled with: the badge's label, and a cell's short source. */
export function tmtAttributedLabel(model: TmtModelScope): string {
  return `TmT-attributed · ${model === 'all' ? 'all four models' : ATTRIBUTION_MODEL_LABELS[model]}`
}

/**
 * The badge on TmT first-party figures: counted from the website's own orders and the
 * visitor's own visits under the named model (or all four), never an ad platform's.
 * Shared by the Advertising page's TmT columns (one website's figures beside Meta's) and
 * the Attribution page (`allWebsites`: every website's production orders).
 */
export function TmtAttributedBadge({
  model,
  lookbackDays,
  className,
  allWebsites = false,
}: {
  model: TmtModelScope
  lookbackDays: number
  className: string
  allWebsites?: boolean
}) {
  const counted = allWebsites
    ? "Counted from your websites' own production orders and their visitors' own visits"
    : "Counted from this website's own orders and the visitor's own visits"
  const credited =
    model === 'all' ? 'credited under each of the four models side by side' : `under the ${ATTRIBUTION_MODEL_LABELS[model].toLowerCase()} model`
  const tooltip = `${counted}, ${credited}, looking back up to ${lookbackDays} days. Never Meta's own count.`
  return <TooltipBadge tone="positive" label={tmtAttributedLabel(model)} tooltip={tooltip} className={className} />
}
